import { EntitiesList } from 'components/eventView/entities/EntitiesList';
import { orderBy } from 'lodash';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    entityId: string;
    align?: 'left' | 'center';
}

export const EntitiesListView = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);

    const entityState = ctxEventView.entityStates[props.entityId];
    const ordered = orderBy(entityState.visible, (e) => e.title?.toLowerCase(), 'asc');

    return (
        <S_EntitiesListView className={props.className}>
            <EntitiesList entityId={props.entityId} align={props.align} items={ordered} />
        </S_EntitiesListView>
    );
};

const S_EntitiesListView = styled.div``;
